import { render, staticRenderFns } from "./AdminUserProfileEdit.vue?vue&type=template&id=61c32ffd&scoped=true"
import script from "./AdminUserProfileEdit.vue?vue&type=script&lang=js"
export * from "./AdminUserProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminUserProfileEdit.vue?vue&type=style&index=0&id=61c32ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c32ffd",
  null
  
)

export default component.exports